<template>
  <div>
    <!-- 面包屑 -->
    <bread-crumb path='内容管理' subPath='专题系列列表'></bread-crumb>
    <!-- 主体列表 -->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="2">
          <el-button type="primary" @click="showAddDialog">添加主题封面合集</el-button>
        </el-col>
      </el-row>
      <el-table :data="list" stripe border :cell-style="{ textAlign: 'center' }">
        <el-table-column prop="id" label="ID" align="center" width="50px"></el-table-column>
        <el-table-column prop="title" label="名称" align="center"></el-table-column>
        <el-table-column label="操作" align="center" width="500px">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-arrow-up" size="mini" :disabled="scope.$index === 0" @click="move(scope.$index, -1)"></el-button>
            <el-button type="primary" icon="el-icon-arrow-down" size="mini" :disabled="scope.$index === list.length - 1" @click="move(scope.$index, 1)"></el-button>
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.id)">编辑</el-button>
            <el-button type="success" size="mini" @click="showCollection(scope.row.id, scope.row.title)">主题封面</el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteRow(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
       @size-change="handleSizeChange"
       @current-change="handleCurrentChange"
       :current-page="param.page"
       :page-sizes="[10, 20, 30, 40, 50]"
       :page-size="param.count"
       layout="total, sizes, prev, pager, next, jumper"
       :total="total">
     </el-pagination>
    </el-card>
    <special-series-add :visible="addDialogAvaible"
      :id="currentId"
      @add="add"
      @update="update"
      @closeDialog="closeAddDialog">
    </special-series-add>
  </div>
</template>

<script>
import BreadCrumb from '../BreadCrumb.vue'
import specialSeriesAdd from './specialSeriesAdd.vue'
export default {
  name: 'special_series_list',
  components: {
    'bread-crumb': BreadCrumb,
    'special-series-add': specialSeriesAdd
  },
  created () {
    this.getList()
  },
  data () {
    return {
      currentId: 0,
      list: [],
      addDialogAvaible: false,
      roleId: 0,
      total: 0,
      pageTotal: 1,
      param: {
        page: 1,
        count: 10
      }
    }
  },
  methods: {
    async getList () {
      const res = await this.$http.get('/admin/special_collection/list', this.param)
      if (res.code === 0) {
        this.list = res.data.list
        this.total = res.data.total
        this.pageTotal = res.data.total_page
      } else {
        this.$message.error(res.msg)
      }
      this.roleId = parseInt(window.sessionStorage.getItem('role_id'))
    },
    async add (data) {
      const res = await this.$http.post('/admin/special_collection/add', data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    async update (id, data) {
      const res = await this.$http.post('/admin/special_collection/update/' + id, data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    handleSizeChange (size) {
      this.param.count = size
      this.getList()
    },
    handleCurrentChange (page) {
      this.param.page = page
      this.getList()
    },
    showAddDialog () {
      this.addDialogAvaible = true
    },
    closeAddDialog () {
      this.addDialogAvaible = false
      this.currentId = 0
    },
    showEditDialog (id) {
      this.currentId = id
      this.showAddDialog()
    },
    async move (index, direction) {
      const current = this.list[index]
      const adjacent = this.list[index + direction]
      if (!adjacent) return
      const res = await this.$http.post('/admin/special_collection/sort/swap/' + current.id, { other_id: adjacent.id })
      if (res.code === 0) this.getList()
      else this.$message.error(res.msg)
    },
    showCollection (id, title) {
      this.$router.push({ path: '/special_collection/items', query: { id: id, title: title } })
    },
    deleteRow (id) {
      this.$confirm('是否真的要删除此记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$http.post('/admin/special_collection/delete/' + id)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.getList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.el-image {
  width: 70px;
}
</style>
